import React, { useEffect, useState } from 'react'

// 여러 화면을 탭 하나로 묶는 껍데기.
//
// 원가관리는 화면이 열 개라 사이드바가 그것만으로 꽉 찼다. 화면 자체는 그대로 두고
// 성격이 같은 것끼리 탭으로만 묶는다 — 증권(업로드·원장·분개)이 쓰는 방식과 같다.
//
// 권한은 탭마다 따로 본다. 메뉴 하나에 화면이 여럿이므로, 권한 없는 탭은 아예 안 보인다.
// 볼 수 있는 탭이 하나도 없으면 이 메뉴 자체가 사이드바에 안 뜬다(App.jsx의 canSee).
export default function CostTabs({ tabs, storeKey, screens, isAdmin, ...rest }) {
  const allowed = tabs.filter((t) => isAdmin || (screens || []).includes(t.screenKey))
  const [key, setKey] = useState(() => {
    try {
      const saved = localStorage.getItem(storeKey)
      if (saved && allowed.some((t) => t.key === saved)) return saved
    } catch {}
    return allowed[0]?.key
  })

  // 권한이 바뀌어 지금 보던 탭이 사라지면 첫 탭으로 돌린다
  useEffect(() => {
    if (allowed.length && !allowed.some((t) => t.key === key)) setKey(allowed[0].key)
  }, [allowed.map((t) => t.key).join(','), key])

  const pick = (k) => {
    setKey(k)
    try { localStorage.setItem(storeKey, k) } catch {}
  }

  if (!allowed.length) return <div className="muted">볼 수 있는 화면이 없습니다.</div>
  const active = allowed.find((t) => t.key === key) || allowed[0]
  const Comp = active.comp

  return (
    <>
      {allowed.length > 1 && (
        <div className="data-tabs">
          {allowed.map((t) => (
            <button key={t.key} type="button"
              className={'data-tab' + (active.key === t.key ? ' active' : '')}
              onClick={() => pick(t.key)}>{t.label}</button>
          ))}
        </div>
      )}
      <Comp screens={screens} isAdmin={isAdmin} {...rest} />
    </>
  )
}
